/* import React, { useEffect, useRef, useState } from "react";
import "./TooltipCell.css";

interface TooltipCellProps {
  children: React.ReactNode;
}

export const TooltipCell: React.FC<TooltipCellProps> = ({ children }) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setShowTooltip(el.scrollWidth > el.clientWidth);
    }
  }, [children]);

  return (
    <div className="tooltip-wrapper">
      <div ref={textRef} className="tooltip-ellipsis">
        {children}
      </div>
      {showTooltip && typeof children === "string" && (
        <div className="tooltip-popup">{children}</div>
      )}
    </div>
  );
};
 */

import React, { useRef, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import "./TooltipCell.css";

interface TooltipCellProps {
  children: React.ReactNode;
}

export const TooltipCell: React.FC<TooltipCellProps> = ({ children }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isOverflowed, setIsOverflowed] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState<{ top: number; left: number } | null>(null);

  useEffect(() => {
    const el = ref.current;
    if (el) {
      const overflow = el.scrollWidth > el.clientWidth;
      setIsOverflowed(overflow);
    }
  }, [children]);

  const handleMouseEnter = () => {
    if (ref.current && isOverflowed) {
      const rect = ref.current.getBoundingClientRect();
      setTooltipPosition({
        top: rect.bottom + window.scrollY + 6,
        left: rect.left + window.scrollX,
      });
    }
  };

  const handleMouseLeave = () => {
    setTooltipPosition(null);
  };

  return (
    <>
      <div
        ref={ref}
        className="tooltip-ellipsis"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </div>

      {tooltipPosition && typeof children === "string" &&
        ReactDOM.createPortal(
          <div
            className="portal-tooltip"
            style={{
              top: tooltipPosition.top,
              left: tooltipPosition.left,
              position: "absolute",
            }}
          >
            {children}
          </div>,
          document.body
        )}
    </>
  );
};
